import { Component, ComponentFactoryResolver, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ActionService, CrudEditComponent, CrudEditorParentService, CrudEditorSelfService, FormStorage, User, UserDetailsViewService, UserDetailsWithAttributes, UserStorage } from '@scisys-uim/uim-common';
import { ASSETS_USER_DETAILS_TYPE } from 'assets-model';
import { AssetsUserDetailsService } from 'assets-service';

@Component({
  selector: 'app-user-editor',
  templateUrl: '../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.html',
  styleUrls: ['../../../../../../../node_modules/@scisys-uim/uim-common/src/lib/crud-components/crud-edit.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class UserEditorComponent extends CrudEditComponent<User, string> implements OnInit {

  userDetailsWithAttributes: UserDetailsWithAttributes;

  constructor(
    route: ActivatedRoute,
    router: Router,
    userStorage: UserStorage,
    protected assetsUserDetailsService: AssetsUserDetailsService,
    private userViewService: UserDetailsViewService,
    dialog: MatDialog,
    snackbar: MatSnackBar,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    private actionService: ActionService,
    private formStorage: FormStorage) {
    super(route, router, userStorage, dialog, snackbar, componentFactoryResolver, injector);
  }

  isSrpUserDetailsExcludedByExistingUserDetailsType(): boolean {
    return this.userDetailsWithAttributes == null || this.assetsUserDetailsService.isUserDetailsExcludedByExistingUserDetailsType(this.userDetailsWithAttributes);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  itemSet() {
    super.itemSet();

    if (this.item?.username != null) {
      this.assetsUserDetailsService.findUserDetailsWithAttributesByUsername(this.item.username).subscribe(item => {
        this.userDetailsWithAttributes = item;
      });
    }

    const self = this;
    this.actions = [];
    if (!this.createMode) {
      var detailsAction = {
        title: ASSETS_USER_DETAILS_TYPE.name,
        enabled: true,
        color: true,
        get available(): boolean {
          return !self.isSrpUserDetailsExcludedByExistingUserDetailsType() && self.userStorage.currentUserHasAnyAuthority(ASSETS_USER_DETAILS_TYPE.viewAuthorities);
        },
        get route(): any[] {
          const keySegments = [self.item.username];
          if (!keySegments) {
            return;
          }
          var routeBase = ASSETS_USER_DETAILS_TYPE.viewRouteBase;
          if (!self.readOnly && self.userStorage.currentUserHasAnyAuthority(ASSETS_USER_DETAILS_TYPE.editAuthorities)) {
            routeBase = ASSETS_USER_DETAILS_TYPE.editRouteBase;
          }
          return [...routeBase, ...keySegments];
        }
      };
      this.actions.push(detailsAction);
    }
  }

}






